// extracted by mini-css-extract-plugin
export var languageSelectCell = "translationEditInterface-module__languageSelectCell___q2YZF";
export var contentCharacterCount = "translationEditInterface-module__contentCharacterCount___jT0ah";